import {
  Activity,
  AlignJustify,
  AlignLeft,
  BarChart3,
  Bell,
  BookOpen,
  Boxes,
  Calendar,
  ClipboardCheck,
  ClipboardList,
  History,
  Home,
  LayoutGrid,
  LineChart,
  Music,
  PackagePlus,
  Percent,
  Receipt,
  RefreshCw,
  Settings2,
  ShieldCheck,
  ShoppingCart,
  Tags,
  TrendingUp,
  Users,
  Wallet,
} from "lucide-react";
import type { ComponentType } from "react";
import type { PermissionModuleAccess, PermissionModuleCode } from "@/types/permissions";

export interface ModuleMetadata {
  id: PermissionModuleCode;
  title: string;
  description: string;
  shortDescription: string;
  icon: ComponentType<{ className?: string }>;
  href: string;
}

const MODULE_ICONS: Record<PermissionModuleCode, ComponentType<{ className?: string }>> = {
  dashboard: BarChart3,
  "daily-sales": TrendingUp,
  "sales-detail": AlignLeft,
  products: LayoutGrid,
  "products-tags": Tags,
  "fichas-tecnicas": AlignJustify,
  compras: ShoppingCart,
  comandas: Receipt,
  agenda: Calendar,
  "agenda-attractions": Music,
  "agenda-analytics": BarChart3,
  "agenda-lembretes": Bell,
  checklists: ClipboardCheck,
  manual: BookOpen,
  "admin-users": Users,
  "admin-roles": ShieldCheck,
  financeiro: Wallet,
  "taxa-servico": Percent,
  analytics: LineChart,
  "estoque-contagem": Boxes,
  "estoque-entrada": PackagePlus,
  "estoque-auditoria": ClipboardList,
  "estoque-auditoria-salvas": ClipboardCheck,
  "estoque-auditoria-timeline": History,
  "estoque-auditoria-metricas": LineChart,
  "estoque-auditoria-consumo": Activity,
  integracoes: RefreshCw,
};

const NAV_ICONS: Record<string, ComponentType<{ className?: string }>> = {
  home: Home,
  sales: BarChart3,
  products: LayoutGrid,
  "fichas-tecnicas": AlignJustify,
  agenda: Calendar,
  checklists: ClipboardCheck,
  manual: BookOpen,
  admin: Settings2,
  "admin-users": Users,
  "admin-roles": ShieldCheck,
  financeiro: Wallet,
  "taxa-servico": Percent,
  estoque: Boxes,
};

export function getModuleIcon(code: PermissionModuleCode): ComponentType<{ className?: string }> {
  return MODULE_ICONS[code] ?? BarChart3;
}

export function getNavigationIcon(code: string, moduleCode?: PermissionModuleCode): ComponentType<{ className?: string }> {
  if (moduleCode) {
    return getModuleIcon(moduleCode);
  }

  return NAV_ICONS[code] ?? BarChart3;
}

export function toModuleMetadata(module: PermissionModuleAccess): ModuleMetadata {
  return {
    id: module.code,
    title: module.name,
    description: module.description ?? module.name,
    shortDescription: module.shortDescription ?? module.description ?? module.name,
    icon: getModuleIcon(module.code),
    href: module.href ?? "/",
  };
}
